import {
  useFloating,
  useInteractions,
  useClick,
} from '@floating-ui/react-dom-interactions';
import { Popover, Transition } from '@headlessui/react';
import { Fragment } from 'react';
interface BaseMenuProps {
  triggerElement: React.ReactNode;
  children: React.ReactNode;
}

const BaseMenu = ({ triggerElement, children }: BaseMenuProps) => {
  const { x, y, reference, floating, strategy, context } = useFloating({
    placement: 'bottom-end',
  });

  const { getReferenceProps } = useInteractions([useClick(context)]);

  return (
    <div>
      <Popover className="relative flex items-center">
        {({ open }) => (
          <>
            <Popover.Button
              {...getReferenceProps()}
              ref={reference}
              className="cursor-pointer outline-hidden"
            >
              {triggerElement}
            </Popover.Button>
            <Transition
              show={open}
              as={Fragment}
              enter="transition duration-150 ease-out"
              enterFrom="opacity-0 -translate-y-1 scale-95"
              enterTo="opacity-100 translate-y-0 scale-100"
              leave="transition duration-100 ease-in"
              leaveFrom="opacity-100 translate-y-0 scale-100"
              leaveTo="opacity-0 -translate-y-1 scale-95"
            >
              <Popover.Panel
                static
                ref={floating}
                className="origin-top-right"
                style={{
                  position: strategy,
                  top: y ?? 0,
                  left: x ?? 0,
                  width: 'max-content',
                  zIndex: 100,
                }}
              >
                {children}
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
};

export default BaseMenu;
